module.exports = __webpack_public_path__ + "img/a05ad15.png";